//const API_URL = "http://localhost:8081/api/auth/";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/auth/`;

function parseJwt(token) {
  try {
    const base64Payload = token.split('.')[1];
    const payload = atob(base64Payload);
    return JSON.parse(payload);
  } catch (e) {
    console.error("JWT parsing failed:", e);
    return null;
  }
}

class AuthService {
  async login(credentials) {
  const response = await fetch(API_URL + "login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });

  let data;
  try {
    data = await response.json(); 
  } catch (err) {
    throw new Error("Backend nije vratio validan JSON");
  }

  if (!response.ok) {
    throw new Error(data?.message || "Login failed");
  }

  // data sada sadrži: { token, id, username, roles, doctorId }
  // Koristimo direktno 'data', ne oslanjamo se na parseJwt za doctorId
  const currentUser = {
    id: data.id,
    token: data.token,
    username: data.username,
    roles: data.roles || [],
    doctorId: data.doctorId, // Ovo je sada onaj ID koji smo poslali iz kontrolera!
  };

  localStorage.setItem("user", JSON.stringify(currentUser));
  return currentUser;
}

  logout() {
    localStorage.removeItem("user");
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getAuthHeader() {
    const user = this.getCurrentUser();
    if (user && user.token) {
      return { Authorization: `Bearer ${user.token}` };
    }
    return {};
  }
}

export default new AuthService();

